import classnames from 'classnames/bind';
import { isEmpty } from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { Icon, IconSize } from 'app/components/core/Icon';
import { Loading, LoadingSize } from 'app/components/core/Loading';
import * as styles from './StateTag.css';

const cx = classnames.bind(styles);

const ICON_BY_STATE = {
    suspended: 'pause',
    started: 'check-circle-solid',
    overloaded: 'status-alert-solid'
};

export function StateTag({ value }) {
    const { t } = useTranslation('common');

    const isPending = isEmpty(value);
    const state = isPending ? 'pending' : value.toLowerCase();
    const icon = ICON_BY_STATE[state];

    return (
        <div className={cx('base', state)}>
            {isPending ? (
                <Loading size={LoadingSize.EXTRA_SMALL} />
            ) : icon ? (
                <Icon variant={icon} size={IconSize.EXTRA_SMALL} />
            ) : null}
            {isPending ? t('pending') : state}
        </div>
    );
}
